import { IFieldInstance } from "../../types/fieldInstance.interface";

export const fieldTypes = {
  Text: "",
  TextArea: "",
  "Number / Currency": "",
  "Date/Time": null,
  Picklist: "",
  Lookup: "",
  TextWithLabel: "",
  CustomBPField: "",
  SecondaryBPField: "",
  "Radio Buttons": "",
  Checkbox: false,
  Togglebox: false,
  "Multi-Select Picklist": [],
  "Multi-Select as CheckBoxes": [],
  "Branched Multi-Select as CheckBoxes": [],
  RelatedList: [],
  CustomWoundComp: "",
};

export const getInitialValue = (fieldType: keyof typeof fieldTypes) => {
  if (fieldTypes[fieldType] === undefined) {
    // add sentry log here
    return "";
  }
  return fieldTypes[fieldType];
};

export const getInitialValues = (fields: IFieldInstance[]) => {
  return fields.reduce((acc: any, current) => {
    const initialValue = getInitialValue(
      current.fieldType as keyof typeof fieldTypes
    );
    acc[current.fieldName] = initialValue;
    return acc;
  }, {});
};

export const isNotEqualToInitialValue = (fieldValue: any) => {
  if (!fieldValue && fieldValue !== undefined) return false;
  if (Array.isArray(fieldValue)) return fieldValue.length !== 0;
  return true;
};
